<template>
	<div>
		<quote-detail-submenu />

		<core-layout-content full>
			<core-layout-headline-and-actions>
				<template slot="headline">{{ $t("transactions") }}</template>
			</core-layout-headline-and-actions>

			<!-- Data Container -->
			<j-card class="bg5">
				<j-data-table
					:header="header"
					:list="computedtransactions"
					:sortable="false"
					:isLoading="isLoading"
					@sort="onSort($event)"
				>
					<template slot="list" slot-scope="{ item }">
						<td v-for="(column, i) in header" :key="i">
							{{ item[column.field] }}
						</td>
					</template>
					<template slot="empty">{{ $t("errors.no_data") }}</template>
				</j-data-table>
			</j-card>
		</core-layout-content>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JBaseInputSearch from "@/components/JBaseInputSearch/"
import JPagination from "@/components/JPagination/"
import CorePaginationInfo from "@/modules/core/components/CorePaginationInfo"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import QuoteDetailSubmenu from "../components/QuoteDetailSubmenu"
import dayjs from "dayjs"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		CrmIcon,
		JButton,
		JCard,
		JDataTable,
		JBaseInputSearch,
		JPagination,
		CorePaginationInfo,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		QuoteDetailSubmenu
	},

	props: {
		// From router
		id: String
	},

	data: () => ({
		isLoading: false,
		transactions: []
	}),

	computed: {
		header() {
			return [
				{ text: this.$t("when"), field: "when" },
				{ text: this.$t("amount"), field: "amount" },
				{ text: this.$t("status"), field: "status" }
			]
		},

		computedtransactions() {
			const transactions = this.transactions
			if (!transactions) return []

			// Crunch transactions
			// Sort to compare and order dates correctly
			// Also reverse them so that most recent one is the most top
			return transactions
				.sort((a, b) => {
					let dateA = a.dateTime
					let dateB = b.dateTime
					if (dateA < dateB) return -1
					if (dateA > dateB) return 1
					return 0
				})
				.map(item => ({
					when: item.dateTime
						? dayjs(item.dateTime).format(
								this.$store.state.settings.dateTimeFormat
						  )
						: null,
					amount: item.formattedTransaction,
					status: this.$t(`transactions_enums.${item.status}`)
				}))
				.reverse()
		}
	},

	methods: {
		async fetchTransactions() {
			this.isLoading = true
			const res = await api.quoteTransactions({
				where: { id: this.id }
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Success
			this.transactions = get(res, "data.policies.list[0].transactions", [])
		}
	},

	created() {
		this.fetchTransactions()
	}
}
</script>
